import { LinkWrap } from '@truphone/gatsby-wrappers'
import React from 'react'

function ArticlesList(props) {
  return (
    <section className="section m-0 grid grid-rows-1" style={{ breakInside: 'avoid' }}>
      <h3 className="font-bold text-xl mt-6 mb-5">{props.title}</h3>

      {props.list &&
        props.list.map((item, i) => {
          return (
            <LinkWrap href={item.href} key={`article-list-content-${i}`} className="mb-5">
              <h4 className="text-base font-medium">{item.title}</h4>
              <p className="text-sm text-navy opacity-60">{item.content}</p>
            </LinkWrap>
          )
        })}
    </section>
  )
}

export default ArticlesList
